module.exports = __webpack_public_path__ + "static/brightly-beams-our-fathers-mercy-01-e223c769055e02ac9316a4015d81db8e.png";